import { AudienceParcoursStubPage } from '../../../../components/parcours/AudienceParcoursStubPage';
import { getTravauxTertiaireStub } from '../../../../config/travaux-tertiaire';

export default function TertiaireCalorifugeagePage() {
  const parcours = getTravauxTertiaireStub('calorifugeage');
  if (!parcours) return null;
  return (
    <AudienceParcoursStubPage
      parcours={parcours}
      audienceId="tertiaire"
      segment="travaux"
      segmentLabel="Travaux"
      crossLinks={[
        {
          label: 'CEE BAT-* tertiaire',
          href: '/tertiaire/aides/cee-bat',
          iconName: 'sparkles',
          hint: "Prime CEE pour la fiche BAT-TH-146",
        },
        {
          label: 'Audit OPERAT',
          href: '/tertiaire/decret-tertiaire',
          iconName: 'gauge',
          hint: "Quick win prioritaire du plan d'actions",
        },
        {
          label: 'Pompe à chaleur tertiaire (fiche BAT-TH-104)',
          href: '/tertiaire/travaux/pac-tertiaire',
          iconName: 'snowflake',
          hint: 'Cohérent avec rénovation chaufferie',
        },
      ]}
      crossLinksAllLabel="Voir toutes les aides tertiaire"
      crossLinksAllHref="/tertiaire/aides"
    />
  );
}
